﻿import { Decorators } from "@serenity-is/corelib";
import { MailDialog } from "../Mail/MailDialog";

@Decorators.registerClass("Profis.TimeTracking.TaskMailDialog")
export class TaskMailDialog extends MailDialog {
}
